// @flow
import { useSelector } from "react-redux";
import { ThemeProvider as SCThemeProvider } from "styled-components";

import createTheme from "./createTheme";

import type { Node } from "react";
import type { Theme } from "./types";

export type Props = {
  +theme?: Theme | Array<Theme>,
  +children: Node,
};

/**
 */
const ThemeProvider = ({ theme, children }: Props): Node => {
  const storedTheme = useSelector(({ preferences }) => preferences.theme);
  const finalTheme = createTheme(storedTheme, theme);

  return <SCThemeProvider theme={finalTheme}>{children}</SCThemeProvider>;
};
ThemeProvider.displayName = "BI.ThemeProvider";

export default ThemeProvider;
